import React, { useState, Children } from 'react';
import { ChevronDown, BookOpen, Gift } from 'lucide-react';
type Block = {
  title: string;
  items: string[];
};
type Bonus = {
  number: number;
  title: string;
  subtitle: string;
  emoji: string;
  intro: string[];
  blocks: Block[];
  biblio: string[];
};
const bonuses: Bonus[] = [{
  number: 1,
  title: '50 JUEGOS DIVERTIDOS PARA RUGBY INFANTIL',
  subtitle: 'Clases más dinámicas, chicos más felices',
  emoji: '🏉',
  intro: ['🏉 Importancia del juego en rugby infantil', '🎯 Aprender jugando', '⚡ Cómo mantener alta la intensidad', '😄 Juegos para motivar a todos los chicos'],
  blocks: [{
    title: 'Bloque 1 — Juegos de Entrada en Calor',
    items: ['🏃 Mancha rugby', '⚡ Carrera de colores', '🥇 Relevos con pelota', '🎯 Cazadores y corredores', '🤸 Activación por estaciones']
  }, {
    title: 'Bloque 2 — Juegos con Pelota Ovalada',
    items: ['🏉 Rey de la ovalada', '✋ Pase y corre', '🔄 Robo de pelotas', '🎯 Pases por equipos', '⚡ Pelota caliente']
  }, {
    title: 'Bloque 3 — Juegos de Velocidad y Reacción',
    items: ['⚡ Semáforo rugby', '👀 Reacción visual', '🏃 Escape del defensor', '🎯 Atrapa conos', '🔥 Sprint competitivo']
  }, {
    title: 'Bloque 4 — Juegos de Tag Rugby',
    items: ['🎀 Robo de cintas', '🛡️ Defensa por zonas', '⚡ Tag en espacios reducidos', '🏉 Mini partidos tag', '🥇 Torneo rápido de tag']
  }, {
    title: 'Bloque 5 — Juegos Competitivos',
    items: ['🏆 Rugby tenis', '🤾 Rugby handball', '⚔️ 1 vs 1', '⚔️ 2 vs 2', '🎮 Rugby combinado']
  }, {
    title: 'Bloque 6 — Juegos Cooperativos',
    items: ['🤝 Cruzar el campo juntos', '🧩 Circuito grupal', '🏉 Transporte de pelota', '🔄 Desafíos colectivos', '😄 Juegos de confianza']
  }, {
    title: 'Bloque 7 — Juegos para Cierre de Clase',
    items: ['🌬️ Vuelta a la calma', '😄 Juego libre controlado', '🏆 Desafío final', '👏 Cierre positivo', '🎉 Mini premiaciones']
  }],
  biblio: ['Rugby Games for Kids', 'World Rugby Coaching Children', 'Teaching Games for Understanding']
}, {
  number: 2,
  title: '30 CLASES ARMADAS DE RUGBY INFANTIL',
  subtitle: 'Entrenamientos listos para usar',
  emoji: '📋',
  intro: ['👨‍🏫 Cómo usar las clases', '🏉 Adaptación según edades', '🔄 Variantes rápidas'],
  blocks: [{
    title: 'Bloque 1 — Clases Iniciales',
    items: ['📋 Clase 1 — Primer contacto con la ovalada', '📋 Clase 2 — Juegos de reacción', '📋 Clase 3 — Pases básicos', '📋 Clase 4 — Coordinación y diversión', '📋 Clase 5 — Tag rugby inicial']
  }, {
    title: 'Bloque 2 — Clases Intermedias',
    items: ['📋 Clase 6 — Ataque y apoyos', '📋 Clase 7 — Defensa básica', '📋 Clase 8 — Circuitos técnicos', '📋 Clase 9 — Juegos competitivos', '📋 Clase 10 — Situaciones reales']
  }, {
    title: 'Bloque 3 — Clases Avanzadas',
    items: ['📋 Clase 11 — Velocidad aplicada', '📋 Clase 12 — Toma de decisiones', '📋 Clase 13 — Mini partidos', '📋 Clase 14 — Defensa en equipo', '📋 Clase 15 — Juego integrado']
  }, {
    title: 'Bloque 4 — Clases Recreativas',
    items: ['🎮 Clase torneo interno', '🏆 Clase olimpiadas rugby', '⚡ Clase desafíos grupales', '🏉 Clase libre guiada', '🎉 Clase especial fin de temporada']
  }],
  biblio: ['Rugby Ready', 'Coaching Youth Rugby', 'Manual UAR Rugby Infantil']
}, {
  number: 3,
  title: 'CIRCUITOS Y ESTACIONES PARA ENTRENAMIENTOS',
  subtitle: 'Entrená sin tiempos muertos',
  emoji: '🔄',
  intro: ['⚡ Beneficios del trabajo por estaciones', '👥 Cómo dividir grupos', '⏱️ Organización eficiente'],
  blocks: [{
    title: 'Bloque 1 — Circuitos Técnicos',
    items: ['🏉 Pase y recepción', '🔄 Apoyos ofensivos', '🎯 Precisión de pases', '⚡ Toma de decisiones']
  }, {
    title: 'Bloque 2 — Circuitos Físicos',
    items: ['🏃 Velocidad', '🤸 Coordinación', '💪 Fuerza infantil', '⚡ Agilidad y reacción']
  }, {
    title: 'Bloque 3 — Circuitos Defensivos',
    items: ['🛡️ Defensa lateral', '🎀 Tag rugby', '🤝 Trabajo con escudos', '🔥 Recuperación defensiva']
  }, {
    title: 'Bloque 4 — Circuitos Mixtos',
    items: ['🏉 Técnica + físico', '🎮 Juegos + velocidad', '⚡ Circuitos competitivos', '🏆 Estaciones por equipos']
  }, {
    title: 'Bloque 5 — Estaciones Recreativas',
    items: ['😄 Juegos rápidos', '🧩 Desafíos grupales', '🎯 Objetivos por tiempo', '🥇 Competencias recreativas']
  }],
  biblio: ['Rugby Skills & Drills', 'Long Term Athlete Development', 'Coaching Better Rugby']
}, {
  number: 4,
  title: 'PLANIFICACIÓN ANUAL DE RUGBY INFANTIL',
  subtitle: 'Toda la temporada organizada',
  emoji: '📅',
  intro: ['🎯 Cómo planificar rugby infantil', '🏉 Objetivos por edades', '📈 Evolución progresiva'],
  blocks: [{
    title: 'Bloque 1 — Pretemporada',
    items: ['⚡ Adaptación física', '🤸 Coordinación general', '🏉 Introducción técnica', '😄 Juegos recreativos']
  }, {
    title: 'Bloque 2 — Primer Trimestre',
    items: ['🏉 Pases y recepción', '🏃 Velocidad básica', '🎀 Tag rugby', '🎯 Juegos de ataque']
  }, {
    title: 'Bloque 3 — Segundo Trimestre',
    items: ['🛡️ Defensa', '⚡ Toma de decisiones', '🏉 Mini partidos', '🔄 Situaciones reales']
  }, {
    title: 'Bloque 4 — Tercer Trimestre',
    items: ['🏆 Competencias internas', '🎮 Juegos avanzados', '⚡ Intensidad y diversión', '👥 Trabajo colectivo']
  }, {
    title: 'Bloque 5 — Cierre de Temporada',
    items: ['🎉 Encuentros recreativos', '🏉 Rugby familiar', '🏆 Premiaciones', '📸 Actividades finales']
  }],
  biblio: ['LTAD Model', 'World Rugby Coaching', 'Desarrollo Deportivo Infantil']
}, {
  number: 5,
  title: 'REDES SOCIALES PARA ESCUELITAS Y CLUBES DE RUGBY',
  subtitle: 'Cómo hacer crecer tu escuelita',
  emoji: '📱',
  intro: ['📱 Importancia de redes sociales', '🏉 Mostrar la esencia del rugby infantil', '🤝 Cómo conectar con familias'],
  blocks: [{
    title: 'Bloque 1 — Ideas de Contenido',
    items: ['📸 Fotos de entrenamientos', '🎥 Videos dinámicos', '🏆 Historias de partidos', '😄 Momentos divertidos']
  }, {
    title: 'Bloque 2 — Historias de Instagram',
    items: ['📱 Encuestas interactivas', '🏉 Trivia rugby', '🔥 Desafíos semanales', '🎯 Stickers y preguntas']
  }, {
    title: 'Bloque 3 — Reels Virales',
    items: ['⚡ Entradas en calor divertidas', '🏃 Circuitos rápidos', '🏉 Jugadas infantiles', '🎶 Ideas de música viral']
  }, {
    title: 'Bloque 4 — Cómo Conseguir Más Alumnos',
    items: ['📢 Publicaciones efectivas', '🎯 Contenido para padres', '🤝 Fidelización', '🏉 Imagen profesional']
  }, {
    title: 'Bloque 5 — Plantillas y Frases',
    items: ['💬 Frases motivadoras', '🏆 Textos para posteos', '📋 Ideas de flyers', '🎉 Anuncios de encuentros']
  }],
  biblio: ['Marketing Deportivo', 'Social Media para Clubes', 'Community Management Deportivo']
}];
export const BonusesAccordion = () => {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <div className="max-w-4xl mx-auto space-y-4" data-id="element-125">
      {bonuses.map((bonus, i) => {
      const isOpen = openIdx === i;
      return <div key={i} className="bg-navy-800 rounded-2xl border-2 border-dashed border-yellow-400/40 overflow-hidden transition-colors hover:border-yellow-400" data-id="element-126">
            <button onClick={() => setOpenIdx(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left" data-id="element-127">
              <div className="flex items-center gap-4 md:gap-5 min-w-0" data-id="element-128">
                <div className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-xl bg-yellow-400/15 border border-yellow-400/50 flex items-center justify-center text-2xl md:text-3xl" data-id="element-129">
                  {bonus.emoji}
                </div>
                <div className="min-w-0" data-id="element-130">
                  <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-131">
                    <span className="text-xs md:text-sm text-yellow-400 font-bold uppercase tracking-widest" data-id="element-132">
                      Bonus {bonus.number}
                    </span>
                    <span className="bg-yellow-400 text-navy-900 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full uppercase" data-id="element-133">
                      GRATIS HOY
                    </span>
                  </div>
                  <h3 className="font-display text-lg md:text-2xl uppercase leading-tight text-white" data-id="element-134">
                    {bonus.title}
                  </h3>
                  <p className="text-slate-400 text-sm md:text-base italic mt-1" data-id="element-135">
                    "{bonus.subtitle}"
                  </p>
                </div>
              </div>
              <ChevronDown className={`w-6 h-6 md:w-8 md:h-8 text-yellow-400 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-136" />
            </button>

            {isOpen && <div className="px-5 md:px-6 pb-6 pt-2 border-t border-yellow-400/20" data-id="element-137">
                {bonus.intro.length > 0 && <div className="bg-yellow-400/5 rounded-xl p-5 border border-yellow-400/20 mt-5 mb-5" data-id="element-138">
                    <div className="flex items-center gap-2 mb-3" data-id="element-139">
                      <Gift className="w-5 h-5 text-yellow-400" data-id="element-140" />
                      <h4 className="font-bold text-white uppercase tracking-wide text-sm" data-id="element-141">
                        Introducción
                      </h4>
                    </div>
                    <ul className="space-y-1.5" data-id="element-142">
                      {bonus.intro.map((item, ii) => <li key={ii} className="text-slate-300 text-sm leading-relaxed" data-id="element-143">
                          {item}
                        </li>)}
                    </ul>
                  </div>}

                <div className="grid md:grid-cols-2 gap-5" data-id="element-144">
                  {bonus.blocks.map((blk, bi) => <div key={bi} className="bg-navy-900 rounded-xl p-5 border border-navy-700" data-id="element-145">
                      <h4 className="font-bold text-base text-yellow-400 mb-3 leading-snug" data-id="element-146">
                        {blk.title}
                      </h4>
                      <ul className="space-y-1.5" data-id="element-147">
                        {blk.items.map((item, ii) => <li key={ii} className="text-slate-300 text-sm leading-relaxed" data-id="element-148">
                            {item}
                          </li>)}
                      </ul>
                    </div>)}
                </div>
              </div>}
          </div>;
    })}
    </div>;
};